module.exports = __webpack_public_path__ + "img/DE02222.dcf0ebf4.png";